// API Configuration centralized for all services
export const API_CONFIG = {
  // Base URLs - Using local development server
  //https://kiloba-api.deploystest.com/api
  //http://localhost:18000/api/admin
  baseURL: 'https://kiloba-api.deploystest.com/api',
  adminBaseURL: 'https://kiloba-api.deploystest.com/api/admin',
  clientBaseURL: 'https://kilobagame.kienlongbank.com',
  wsURL: 'wss://kiloba-api.deploystest.com/ws',
  
  // Feature flags
  enableMockAPI: import.meta.env.VITE_ENABLE_MOCK_API === 'true',
  cacheEnabled: import.meta.env.VITE_CACHE_ENABLED !== 'false',
  retryEnabled: import.meta.env.VITE_RETRY_ENABLED !== 'false',
  
  // Debug flags
  debugAPI: import.meta.env.VITE_DEBUG_API === 'true',
  debugWS: import.meta.env.VITE_DEBUG_WS === 'true',
  
  // Timeout settings
  defaultTimeout: 10000, // 10 seconds
  authTimeout: 5000,     // 5 seconds
  
  // Retry settings
  maxRetryAttempts: 3,
  retryDelay: 1000,
  
  // Cache settings
  cacheTimeout: 5 * 60 * 1000, // 5 minutes
} as const;

// Endpoints configuration
export const ENDPOINTS = {
  auth: {
    login: '/auth/login',
    logout: '/auth/logout',
    refresh: '/auth/refresh',
    profile: '/auth/profile',
  },
  admin: {
    dashboard: '/dashboard',
    users: '/users',
    games: '/games',
    vouchers: '/vouchers',
    tasks: '/tasks',
    miniQuiz: '/mini-quiz',
    health: '/health',
  },
  users: {
    list: '/users',
    create: '/users',
    update: '/users',
    delete: '/users',
    profile: '/users/profile',
  },
  games: {
    list: '/games',
    create: '/games',
    update: '/games',
    delete: '/games',
  },
  vouchers: {
    list: '/vouchers',
    create: '/vouchers',
    update: '/vouchers',
    delete: '/vouchers',
  },
} as const;

// WebSocket configuration
export const WS_CONFIG = {
  url: API_CONFIG.wsURL,
  reconnectInterval: 3000,
  maxReconnectAttempts: 5,
  heartbeatInterval: 30000,
  debug: API_CONFIG.debugWS,
} as const;

// Helper functions
export const getFullUrl = (endpoint: string, isAdmin = false): string => {
  const baseUrl = isAdmin ? API_CONFIG.adminBaseURL : API_CONFIG.baseURL;
  return `${baseUrl}${endpoint}`;
};

export const getAdminUrl = (endpoint: string): string => {
  return getFullUrl(endpoint, true);
};

export const getWsUrl = (): string => {
  return API_CONFIG.wsURL;
};
